/** Option lists aligned with v90 prototype screens. */

export const V90_GENDER_OPTIONS = [
  'Agender',
  'Bigender',
  'Cisgender',
  'Gender questioning',
  'Genderfluid',
  'Genderqueer',
  'Man',
  'Non-binary',
  'Trans feminine',
  'Trans',
  'Trans masculine',
  'Woman',
];

export const V90_ORIENTATION_OPTIONS = [
  'Aromantic',
  'Asexual',
  'Bi-curious',
  'Bisexual',
  'Demiromantic',
  'Demisexual',
  'Dyke',
  'Gay',
  'Gray-A',
  'Heteroflexible',
  'Homoflexible',
  'Lesbian',
  'Pansexual',
  'Polysexual',
  'Queer',
  'Sapphic',
];

export const V90_PRONOUN_OPTIONS = [
  'any/all',
  'he/him',
  'he/they',
  'she/her',
  'she/they',
  'they/them',
  'None',
  'xe/xem',
];

export const V90_LANGUAGE_OPTIONS = [
  'English',
  'French',
  'German',
  'Spanish',
  'Italian',
  'Portuguese',
  'Dutch',
  'Polish',
  'Turkish',
  'Arabic',
  'Hebrew',
  'Russian',
  'Mandarin',
  'Japanese',
  'Korean',
  'Hindi',
  'Swedish',
  'Norwegian',
  'Danish',
  'Greek',
  'Czech',
  'Bosnian',
  'Croatian',
  'Serbian',
  'Urdu',
  'Hungarian',
  'Romanian',
  'Ukrainian',
  'Vietnamese',
  'Thai',
  'Indonesian',
  'Filipino',
  'Swahili',
  'Yoruba',
  'Other',
];

export const V90_ETHNICITY_OPTIONS = [
  'BIPOC',
  'Black / African descent',
  'East Asian',
  'Hispanic / Latino',
  'Indigenous',
  'Mixed / Multiracial',
  'Slavic',
  'South Asian',
  'Southeast Asian',
  'SWANA',
  'White',
  'Other',
  'Prefer not to say',
];

export const V90_OPEN_TO_OPTIONS = [
  'Casual romance',
  'Friendship',
  'Long-term romance',
  'One time things',
];

export const V90_RELATIONSHIP_TYPE_OPTIONS = [
  'Monogamous',
  'Non-monogamous',
  'None',
  'Open',
  'Polyamorous',
  'Undefined',
];

export const V90_RELATIONSHIP_STATUS_OPTIONS = ['Dating', 'In a relationship', 'Married', 'Single'];

export const V90_INTEREST_OPTIONS = [
  'Art',
  'Astrology',
  'Ballroom',
  'Board games',
  'Books',
  'Bouldering',
  'Cooking',
  'Dancing',
  'Drawing',
  'DIY',
  'Fashion',
  'Festivals',
  'Film',
  'Food & Drink',
  'Gaming',
  'Hiking',
  'Meditation',
  'Music',
  'Manga',
  'Nightlife',
  'Outdoors',
  'Photography',
  'Podcasts',
  'Politics',
  'Running',
  'Sober life',
  'Socializing',
  'Soccer',
  'Sports',
  'Spirituality',
  'Theatre',
  'Travel',
  'Wellness',
  'Writing',
];

export const V90_INTIMACY_OPTIONS = [
  'BDSM',
  'Bondage',
  'Discipline',
  'Domination',
  'Exhibitionism',
  'Group sex',
  'Impact play',
  'Kink-curious',
  'Light kink',
  'Oral',
  'Power exchange',
  'Role play',
  'Sensory play',
  'Soft kink',
  'Submission',
  'Tantric',
  'Voyeurism',
];

export const SPOT_GROUP_DEFINITIONS = [
  {
    id: 'bar-and-others',
    label: 'Bar & other venues',
    categories: ['bar', 'cafe'],
  },
  {
    id: 'culture',
    label: 'Culture',
    categories: ['cinema', 'exhibition', 'museum', 'theater', 'gallery', 'opera', 'cultural'],
  },
  {
    id: 'nightlife',
    label: 'Nightlife',
    categories: ['club'],
  },
  {
    id: 'outside',
    label: 'Outside',
    categories: ['outdoors'],
  },
];

/** v90 city typeahead allowlist — replace with geocoding autocomplete before prod. */
export const V90_CITY_SUGGESTIONS = [
  'Amsterdam',
  'Antwerp',
  'Athens',
  'Barcelona',
  'Belgrade',
  'Berlin',
  'Birmingham',
  'Bologna',
  'Bordeaux',
  'Bratislava',
  'Brussels',
  'Bucharest',
  'Budapest',
  'Cologne',
  'Copenhagen',
  'Dublin',
  'Edinburgh',
  'Florence',
  'Frankfurt',
  'Geneva',
  'Glasgow',
  'Gothenburg',
  'Hamburg',
  'Helsinki',
  'Istanbul',
  'Krakow',
  'Lille',
  'Lisbon',
  'Liverpool',
  'Ljubljana',
  'London',
  'Lyon',
  'Madrid',
  'Manchester',
  'Marseille',
  'Milan',
  'Montpellier',
  'Munich',
  'Nantes',
  'Naples',
  'Nice',
  'Oslo',
  'Paris',
  'Porto',
  'Prague',
  'Reykjavik',
  'Riga',
  'Rome',
  'Rotterdam',
  'Sevilla',
  'Sofia',
  'Stockholm',
  'Strasbourg',
  'Stuttgart',
  'Tallinn',
  'Toulouse',
  'Turin',
  'Valencia',
  'Venice',
  'Vienna',
  'Vilnius',
  'Warsaw',
  'Zagreb',
  'Zurich',
  'Montreal',
  'Toronto',
  'Vancouver',
  'New York',
  'Brooklyn',
  'Los Angeles',
  'San Francisco',
  'Chicago',
  'Boston',
  'Washington',
  'Portland',
  'Seattle',
  'Austin',
  'Mexico City',
  'Tel Aviv',
  'Sydney',
  'Melbourne',
  'Tokyo',
  'Seoul',
  'Bangkok',
  'Singapore',
  'Hong Kong',
  'Cape Town',
  'Johannesburg',
  'Buenos Aires',
  'São Paulo',
  'Rio de Janeiro',
];
